module.exports = __webpack_public_path__ + "static/9invgde-d0b34a856aec0b1e501bf9c294920513.gif";